/*
 * Module for handling of pay items edit view
 */
rs.module("content/employer/account/payitems/edit",

    [
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (selectHelper, eventBanner) {

        var _executeSelectionChanged;

        // initialize the module
        function initialize(jsSelectors, columnIds, grid, ajaxUrl) {

            // This page either has two edit forms (paramsForm and detailsForm) or one addForm containing the same content
            var addForm = $.js(jsSelectors.addForm, { required: false });
            var detailsForm = $.js(jsSelectors.detailsForm, { required: false });

            var payItemCategoryKey = detailsForm.length > 0 ? detailsForm.js(jsSelectors.payItemCategoryKey) : addForm.js(jsSelectors.payItemCategoryKey);
            var salaryCategory = detailsForm.length > 0 ? detailsForm.js(jsSelectors.salaryCategory) : addForm.js(jsSelectors.salaryCategory);
            var salaryCategorySelectHelper = selectHelper.getHelper(salaryCategory, { required: false });

            var effectiveDate = detailsForm.length > 0 ? detailsForm.js(jsSelectors.effectiveDate) : addForm.js(jsSelectors.effectiveDate);
            var terminationDate = detailsForm.length > 0 ? detailsForm.js(jsSelectors.terminationDate) : addForm.js(jsSelectors.terminationDate);
            var detailUpdateToken = detailsForm.length > 0 ? detailsForm.js(jsSelectors.detailUpdateToken) : addForm.js(jsSelectors.detailUpdateToken);

            // these two controls only exist in edit mode
            var addDetailLink = detailsForm.js(jsSelectors.addDetailLink, { required: false });
            var cancelDetailButton = detailsForm.js(jsSelectors.cancelDetailButton, { required: false });

            // this control only exists in add mode
            var shouldAddCategory = addForm.js(jsSelectors.shouldAddCategory, { required: false });

            if (shouldAddCategory) {
                shouldAddCategory.change(shouldAddCategoryChanged);
            }

            // enable/disable category fields according to checkbox
            function shouldAddCategoryChanged() {
                if (shouldAddCategory.is(":checked")) {
                    salaryCategorySelectHelper.setDisabled(false);
                    effectiveDate.prop("disabled", false);
                    terminationDate.prop("disabled", false);
                }
                else {
                    salaryCategorySelectHelper.setValue("");
                    salaryCategorySelectHelper.setDisabled(true);
                    salaryCategory.clearErrors();
                    effectiveDate.val('').prop("disabled", true).clearErrors();
                    terminationDate.val('').prop("disabled", true).clearErrors();
                }
            }

            if (grid) {
                addDetailLink.on("click", addDetailClicked);
                cancelDetailButton.on("click", cancelDetailClicked);

                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();

                        $.get(
                            ajaxUrl,
                            { salaryPayItemCategoryKey: rows[0][columnIds.salaryPayItemCategoryKey] },

                            function (data) {
                                salaryCategorySelectHelper.setValue(data.salaryCategoryKey);
                                salaryCategory.clearErrors();
                                effectiveDate.val(data.effectiveDate ? new Date(data.effectiveDate).toISODateString() : null).clearErrors();
                                terminationDate.val(data.terminationDate ? new Date(data.terminationDate).toISODateString() : null).clearErrors();
                                payItemCategoryKey.val(data.salaryPayItemCategoryKey);
                                detailUpdateToken.val(data.updateToken);
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });

                // clear errors, current values, and grid selection when the add detail button is clicked
                function addDetailClicked() {
                    eventBanner.removeAllMessages();

                    salaryCategorySelectHelper.setValue(null);
                    salaryCategory.clearErrors();
                    effectiveDate.val('').clearErrors();
                    terminationDate.val('').clearErrors();
                    payItemCategoryKey.val(-1);

                    grid.selectedValues = null;
                }

                // clear errors and reset grid selection to first row
                function cancelDetailClicked() {
                    eventBanner.removeAllMessages();

                    salaryCategorySelectHelper.setValue(null);
                    salaryCategory.clearErrors();
                    effectiveDate.val('').clearErrors();
                    terminationDate.val('').clearErrors();
                    payItemCategoryKey.val(-1);

                    grid.selectedValues = null;
                    grid.selectFirstRow();
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);